var chatbotInstance;

$(document).ready(function () {
    if (siteMetaData.chatbotContentItemIds.length > 0) {
        var chatbotDetailsPromise = getSFChatbotDetails(siteMetaData.chatbotContentItemIds);
        chatbotDetailsPromise.then(
            function (chatbotList) {
                chatbotInstance = new CustomChatbot();
                chatbotInstance.displayChatbot(chatbotList);
            },
            function (error) {
                console.error(error);
            }
        );
    }
});

function getSFChatbotDetails(contentItemIds) {
    return new Promise((resolve, reject) => {
        let queryString = contentItemIds.map(item => `contentItemIds=${encodeURIComponent(item)}`).join('&');
        let currentPage = encodeURIComponent(window.location.pathname);
        queryString += `&currentPage=${currentPage}`;

        $.ajax({
            url: '/chatbot?' + queryString,
            type: "GET",
            success: function (data) {
                data.forEach(function (chatbotDetail) {
                    if (chatbotDetail.abTestingEventName) {
                        window.clarity("set", "chatbotABEventName", chatbotDetail.abTestingEventName);
                    }
                });
                resolve(data);
            },
            error: function (error) {
                reject(error);
            }
        });
    });
}